// extracted by mini-css-extract-plugin
export default {"Container":"denied_Container__hALjq","modal":"denied_modal__YkKCQ","bounce":"denied_bounce__YTTpK","overlay":"denied_overlay__waq-D","wrapper":"denied_wrapper__0nsC5"};